import { Route } from "react-router-dom";
import { lazyWithRetry as lazy } from "@/lib/lazyWithRetry";
import ProtectedRoute from "@/components/ProtectedRoute";
import FeatureRoute from "@/components/FeatureRoute";

const MembresLayout = lazy(() => import("@/pages/membres/MembresLayout"));
const MembresListPage = lazy(() => import("@/pages/membres/MembresListPage"));
const MembreDetailPage = lazy(() => import("@/pages/membres/MembreDetailPage"));
const MembreHistoriquePage = lazy(() => import("@/pages/membres/MembreHistoriquePage"));
const RenouvellementsPage = lazy(() => import("@/pages/membres/RenouvellementsPage"));
const ClientsFidelesPage = lazy(() => import("@/pages/membres/ClientsFidelesPage"));
const ClientFideleDetailPage = lazy(() => import("@/pages/membres/ClientFideleDetailPage"));
const PromotionsLayout = lazy(() => import("@/pages/promotions/PromotionsLayout"));
const PromotionsListPage = lazy(() => import("@/pages/promotions/PromotionsListPage"));
const PromotionFormPage = lazy(() => import("@/pages/promotions/PromotionFormPage"));
const PromotionSimulateurPage = lazy(() => import("@/pages/promotions/PromotionSimulateurPage"));
const PromotionHistoriquePage = lazy(() => import("@/pages/promotions/PromotionHistoriquePage"));
const MotifsConfigPage = lazy(() => import("@/pages/promotions/MotifsConfigPage"));

export function membresPromotionsRoutes() {
  return (
    <>
      {/* Membres */}
      <Route
        element={
          <ProtectedRoute allowedRoles={["gerante", "admin", "caissiere", "pdg", "controleur"]}>
            <FeatureRoute flag="pos.membres"><MembresLayout /></FeatureRoute>
          </ProtectedRoute>
        }
      >
        <Route path="/membres" element={<MembresListPage />} />
        <Route path="/membres/fideles" element={<ClientsFidelesPage />} />
        <Route path="/membres/fideles/:id" element={<ClientFideleDetailPage />} />
        <Route path="/membres/renouvellements" element={<RenouvellementsPage />} />
        <Route path="/membres/:id" element={<MembreDetailPage />} />
        <Route path="/membres/:id/historique" element={<MembreHistoriquePage />} />
      </Route>

      {/* Promotions */}
      <Route
        element={
          <ProtectedRoute allowedRoles={["gerante", "admin"]}>
            <FeatureRoute flag="pos.promotions"><PromotionsLayout /></FeatureRoute>
          </ProtectedRoute>
        }
      >
        <Route path="/promotions" element={<PromotionsListPage />} />
        <Route path="/promotions/nouvelle" element={<PromotionFormPage />} />
        <Route path="/promotions/simulateur" element={<PromotionSimulateurPage />} />
        <Route path="/promotions/historique" element={<PromotionHistoriquePage />} />
        <Route path="/promotions/motifs" element={<MotifsConfigPage />} />
        <Route path="/promotions/:id" element={<PromotionFormPage />} />
      </Route>
    </>
  );
}
